import 'lazysizes'; // 100kb
// JS Cookie
const Cookies = require('./libraries/js.cookie');

try {
    window.$ = window.jQuery = require('jquery'); // vendor
} catch (e) {}